module.exports = __webpack_public_path__ + "assets/images/eurosport_2.e26062355af3616f1478993650e42b5a.png";